import Checkout from "../checkout/checkout.component";
import MenuSearch from "../menuSearch/menuSearch.component";
import MobileCheckout from "../mobileCheckout/mobileCheckout.component";
import RestOrderMenu from "../restOrderMenu/restOrderMenu.component";
import "./tableside.styles.scss";

const Tableside = () => {
  return (
    <div className="rest-tab-container">
      {window.innerWidth > 1024 ? (
        <div className="rest-tab-desktop">
          <div className="rest-tab-menu">
            <div className="rest-tab-menubox">
              <MenuSearch />
              <RestOrderMenu />
            </div>
          </div>
          <Checkout />
        </div>
      ) : (
        <div className="rest-tab-mobile">
          <div className="rest-tab-menu">
            <div className="rest-tab-menubox">
              <MenuSearch />
              <RestOrderMenu />
            </div>
          </div>
          <MobileCheckout />
        </div>
      )}
    </div>
  );
};
export default Tableside;
